import { ActiveCall } from '../types';

const extractPhoneNumber = (customer: ActiveCall['customer']): string | undefined => (typeof customer?.phoneNumber === 'string'
    ? customer?.phoneNumber
    : customer?.phoneNumber?.phoneNumber);

export default extractPhoneNumber;
